import "core-js/modules/es.number.constructor.js";
import activityinfo from './activityinfo.vue';
import activityproduct from './activityProduct2';
import specialoffer from './specialoffer.vue';
import integraldoubling from './integraldoubling.vue';
import activityDyx from './addactivity/activityDyx.vue';
export default {
  name: 'EditActivity',
  i18n: require('./i18n-activity'),
  components: {
    activityinfo: activityinfo,
    activityproduct: activityproduct,
    specialoffer: specialoffer,
    integraldoubling: integraldoubling,
    activityDyx: activityDyx
  },
  data: function data() {
    return {
      activityId: 0,
      activityType: 0,
      type: 1
    };
  },
  activated: function activated() {
    // this.activityType=Number(this.$route.query.activityType)
    this.activityId = Number(this.$route.query.id);
  },
  created: function created() {
    // this.activityType=Number(this.$route.query.activityType)
    this.activityId = Number(this.$route.query.id);
  },
  methods: {
    callback: function callback(key) {
      this.type = Number(key);
    }
  }
};